import { dkAddressLine, } from '@debbie/common/dist/addresses/adressevaelger.js';
import { CountryCode, addressToString, validateAddress, } from '@debbie/common/dist/index.js';
import { useTenant } from '@debbie/cortex/dist/tenant/index.js';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import AddressFinder from './AddressFinder.js';
import Button from './Button.js';
import { Col, Row } from './Grid/index.js';
import { Edit } from './Icons/index.js';
import { ButtonGroup, Modal } from './index.js';
import Input from './Input.js';
import Well from './Well.js';
const countryCodeLangMap = {
    [CountryCode.GL]: 'Grønland',
    [CountryCode.DK]: 'Danmark',
    [CountryCode.NO]: 'Norge',
    [CountryCode.SE]: 'Sverige',
};
var EditingStates;
(function (EditingStates) {
    EditingStates["no"] = "no";
    EditingStates["search"] = "search";
})(EditingStates || (EditingStates = {}));
const AddressInput = (props) => {
    const lang = useSelector((s) => s.lang);
    const tenant = useTenant();
    const [editing, setEditing] = useState(EditingStates.no);
    const [focusNoEditInput, setFocusNoEditInput] = useState(false);
    const [editAddressModalOpen, setEditAddressModalOpen] = useState(false);
    const [address, setAddress] = useState({
        address: '',
        zipcode: '',
        city: '',
    });
    const noSearch = tenant ? tenant.countryCode != CountryCode.DK : false;
    const noEditRef = useRef(null);
    useEffect(() => {
        if (props.address && props.address !== address) {
            setAddress({
                address: props.address.address,
                coAddress: props.address.coAddress,
                city: props.address.city,
                zipcode: props.address.zipcode,
                country: props.address.country,
            });
        }
    }, [props.address]);
    const changeState = (state) => {
        setEditing(state);
        if (props.notUpdateOnEditingStateChange) {
            return;
        }
    };
    const submitAddress = (address) => {
        props.onChange && props.onChange(address);
        setEditing(EditingStates.no);
        if (!noSearch) {
            setFocusNoEditInput(true);
        }
    };
    useEffect(() => {
        if (focusNoEditInput) {
            if (noEditRef.current) {
                // @ts-ignore
                noEditRef.current?.focus();
            }
        }
    }, [focusNoEditInput]);
    const formatAddress = (dkAddress) => ({
        address: dkAddressLine(dkAddress),
        coAddress: null,
        city: dkAddress.accessAddress.city,
        zipcode: dkAddress.accessAddress.zipcode,
        country: 'Danmark',
        DK_AdresseId: dkAddress.id,
    });
    return (React.createElement(React.Fragment, null,
        (() => {
            switch (editing) {
                case 'no':
                    return (React.createElement("div", { className: props.className, onClick: props.onClick },
                        React.createElement(Input, { onClick: () => changeState(EditingStates.search), placeholder: props.placeholder || lang.inputs.address, onChange: () => { }, value: props.address && props.address.address
                                ? addressToString(props.address)
                                : '', onFocus: (e) => {
                                if (focusNoEditInput) {
                                    setFocusNoEditInput(false);
                                }
                                else if (noSearch) {
                                    e.preventDefault();
                                    setEditAddressModalOpen(true);
                                }
                                else {
                                    changeState(EditingStates.search);
                                }
                            }, inputRef: noEditRef, onKeyDown: (e) => {
                                if (![9, 16].includes(e.keyCode)) {
                                    changeState(EditingStates.search);
                                }
                            } })));
                case 'search':
                    return (React.createElement("div", { className: props.className, onClick: props.onClick }, React.createElement(AddressFinder, { button: {
                            value: React.createElement(Edit, null),
                            onClick: () => {
                                setEditAddressModalOpen(!editAddressModalOpen);
                            },
                            tabIndex: -1,
                        }, autofocus: props.autofocus || true, onSelect: (result) => {
                            const address = formatAddress(result);
                            submitAddress(address);
                        }, onBlur: () => {
                            setTimeout(() => {
                                changeState(EditingStates.no);
                            }, 200);
                        } })));
                default:
                    return null;
            }
        })(),
        editAddressModalOpen && (React.createElement(Modal, { maxWidth: "500px", onToggle: () => setEditAddressModalOpen(!editAddressModalOpen), header: props.placeholder || lang.inputs.address },
            React.createElement("div", { className: props.className, onClick: props.onClick },
                React.createElement(Well, null,
                    React.createElement(Row, null,
                        React.createElement(Col, { width: "12" },
                            React.createElement(Input, { autofocus: true, placeholder: lang.inputs.address, value: (address && address.address) || '', onChange: (e) => setAddress((addr) => {
                                    return {
                                        ...address,
                                        address: e.target.value,
                                        country: addr.country ??
                                            (tenant &&
                                                countryCodeLangMap[tenant.countryCode]) ??
                                            'Danmark',
                                    };
                                }) })),
                        React.createElement(Col, { width: "12" },
                            React.createElement(Input, { placeholder: lang.inputs.co, value: (address && address.coAddress) || '', onChange: (e) => setAddress({
                                    ...address,
                                    coAddress: e.target.value && e.target.value != ''
                                        ? e.target.value
                                        : null,
                                }) })),
                        React.createElement(Col, { width: "4" },
                            React.createElement(Input, { placeholder: lang.inputs.zipcode, value: (address && address.zipcode) || '', onChange: (e) => setAddress({
                                    ...address,
                                    zipcode: e.target.value,
                                }) })),
                        React.createElement(Col, { width: "8" },
                            React.createElement(Input, { placeholder: lang.inputs.city, value: (address && address.city) || '', onChange: (e) => setAddress({
                                    ...address,
                                    city: e.target.value,
                                }) })),
                        React.createElement(Col, { width: "12" },
                            React.createElement(Input, { placeholder: lang.inputs.country, value: (address && address.country) || '', onChange: (e) => setAddress({
                                    ...address,
                                    country: e.target.value,
                                }) })),
                        React.createElement(Col, { width: "12" },
                            React.createElement("br", null),
                            React.createElement(ButtonGroup, null,
                                React.createElement(Button, { size: "small", onClick: () => {
                                        if (address && address.address) {
                                            submitAddress(address);
                                        }
                                        setEditAddressModalOpen(false);
                                    }, disabled: !validateAddress(address) }, lang.inputs.done),
                                React.createElement(Button, { size: "small", theme: "secondary", onClick: () => {
                                        submitAddress(null);
                                        setEditAddressModalOpen(false);
                                    } }, lang.inputs.removeAddress))))))))));
};
export default AddressInput;
//# sourceMappingURL=AddressInput.js.map